/**
 * The axis titles a `ChartFrame` hands the chart inside it.
 *
 * A frame is given `xLabel`/`yLabel` once, and every axis-bearing primitive under it draws
 * them without the call site repeating the words on the chart as well. A primitive's own
 * `xLabel`/`yLabel` props still win, for a frame that holds two charts with different axes.
 * The lightbox provides the same context around its copy of the chart, which is rendered in
 * a portal outside the frame's tree.
 */
import { createContext, useContext } from 'react';

export interface ChartAxisTitles {
  xLabel?: string;
  yLabel?: string;
}

export const ChartAxisContext = createContext<ChartAxisTitles>({});

/** The axis titles to draw: the chart's own props first, then its frame's. */
export function useAxisTitles(xLabel?: string, yLabel?: string): ChartAxisTitles {
  const frame = useContext(ChartAxisContext);
  return { xLabel: xLabel ?? frame.xLabel, yLabel: yLabel ?? frame.yLabel };
}
